import { createAction, props } from '@ngrx/store';
import {
  CustomerDepartmentAddFavoriteQualificationsRequest,
  CustomerDepartmentAddRequirementsRequest,
  CustomerDepartmentCreateRequest,
  CustomerDepartmentQualificationCreateRequest,
  CustomerDepartmentResponse,
  CustomerDepartmentUpdateRequest,
  CustomerDepartmentUpdateShiftTimesRequest,
  DepartmentListItemResponse,
  UpdateUsersRequest,
  UserItemResponse,
} from '../../../api';

// Department
export const loadCustomerDepartment = createAction(
  '[Customer Department] Load department info',
  props<{ payload: { department: number } }>()
);
export const setCustomerDepartment = createAction(
  '[Customer Department] Set department info',
  props<{ payload: CustomerDepartmentResponse }>()
);
export const successCustomerDepartment = createAction('[Customer Department] Success department info');
export const errorCustomerDepartment = createAction('[Customer Department] Error department info');
export const resetCustomerDepartment = createAction('[Customer Department] Reset department info');

// Copy Department
export const copyCustomerDepartment = createAction(
  '[Customer Department] Copy department info',
  props<{ payload: { location: number; department: number; searchTerm?: string } }>()
);
export const successCopyCustomerDepartment = createAction('[Customer Department] Success copy department info');
export const errorCopyCustomerDepartment = createAction('[Customer Department] Error copy department info');

// Customer users
export const loadCustomerUsers = createAction(
  '[Customer Department] Load customer users',
  props<{
    payload: {
      roles?: ('user' | 'admin' | 'workCouncil')[];
      active?: boolean;
      search?: string;
    };
  }>()
);
export const setCustomerUsers = createAction(
  '[Customer Department] Set customer users',
  props<{ payload: UserItemResponse[] }>()
);
export const successCustomerUsers = createAction('[Customer Department] Success customer users');
export const errorCustomerUsers = createAction('[Customer Department] Error customer users');

// Active customer user list
export const loadCustomerActiveUserList = createAction(
  '[Customer Department] Load customer active user list',
  props<{ payload?: { search?: string } }>()
);
export const setCustomerActiveUserList = createAction(
  '[Customer Department] Set active user list',
  props<{ payload: UserItemResponse[] | undefined }>()
);
export const successCustomerActiveUserList = createAction('[Customer Department] Success customer active user list');
export const errorCustomerActiveUserList = createAction('[Customer Department] Error customer active user list');

// Update users
export const updateUsersToCustomerDepartment = createAction(
  '[Customer Department] Update users',
  props<{
    payload: { department: number; customer: number; location: number; body: UpdateUsersRequest };
  }>()
);

// Update master data
export const updateCustomerDepartmentMasterData = createAction(
  '[Customer Department] Update master data',
  props<{
    payload: {
      department: number;
      customer: number;
      location: number;
      body: CustomerDepartmentUpdateRequest;
      search?: string;
    };
  }>()
);

// Update shift times
export const updateCustomerDepartmentShiftTimes = createAction(
  '[Customer Department] Update shift times',
  props<{
    payload: {
      department: number;
      customer: number;
      location: number;
      body: CustomerDepartmentUpdateShiftTimesRequest;
    };
  }>()
);

export const successUpdateCustomerDepartmentShiftTimes = createAction(
  '[Customer Department] Success Update shift times'
);
export const errorUpdateCustomerDepartmentShiftTimes = createAction('[Customer Department] Error Update shift times');

// Update requirements
export const updateCustomerDepartmentRequirements = createAction(
  '[Customer Department] Update requirements',
  props<{
    payload: {
      department: number;
      customer: number;
      location: number;
      body: CustomerDepartmentAddRequirementsRequest;
    };
  }>()
);
export const successUpdateCustomerDepartmentRequirements = createAction(
  '[Customer Department] Success Update requirements'
);
export const errorUpdateCustomerDepartmentRequirements = createAction(
  '[Customer Department] Error Update requirements'
);

// Delete requirement
export const deleteCustomerDepartmentRequirement = createAction(
  '[Customer Department] Delete requirement',
  props<{ payload: { department: number; customer: number; location: number; requirement: number } }>()
);
export const successDeleteCustomerDepartmentRequirement = createAction(
  '[Customer Department] Success Delete requirement'
);
export const errorDeleteCustomerDepartmentRequirement = createAction('[Customer Department] Error Delete requirement');

// Create department
export const createDepartmentCrud = createAction(
  '[Customer Department] Create department',
  props<{
    payload: {
      location: number;
      body: CustomerDepartmentCreateRequest;
      search?: string;
    };
  }>()
);
export const setDepartmentCrud = createAction(
  '[Customer Department] Set department',
  props<{ payload: DepartmentListItemResponse }>()
);
export const successDepartmentCrud = createAction('[Customer Department] Success create department');
export const errorDepartmentCrud = createAction('[Customer Department] Error create department');

// Add favourite qualifications to department
export const addFavouriteQualifications = createAction(
  '[Customer Department] Add favourite qualifications to department',
  props<{
    payload: {
      department: number;
      location: number;
      body: CustomerDepartmentAddFavoriteQualificationsRequest;
      callback?: () => void;
    };
  }>()
);
export const addFavouriteQualificationsSuccess = createAction(
  '[Customer Department] Success add favourite qualifications to department'
);
export const addFavouriteQualificationsError = createAction(
  '[Customer Department] Error add favourite qualifications to department'
);

// Delete favourite qualification from department
export const deleteFavouriteQualification = createAction(
  '[Customer Department] Delete favourite qualification from department',
  props<{ payload: { department: number; qualification: number; location: number; callback?: () => void } }>()
);
export const deleteFavouriteQualificationSuccess = createAction(
  '[Customer Department] Success delete favourite qualification from department'
);
export const deleteFavouriteQualificationError = createAction(
  '[Customer Department] Error delete favourite qualification from departmentt'
);

// Update customer department qualifications job description
export const updateDepartmentQualificationDescription = createAction(
  '[Customer Department] Update customer department qualifications job description',
  props<{
    payload: {
      qualification: number;
      department: number;
      body: CustomerDepartmentQualificationCreateRequest;
      location: number;
    };
  }>()
);
